module.exports = __webpack_public_path__ + "bariol_bold_italic-webfont.asset.58b26763f980161df9d264e3ffcfceea.woff";